var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1882,
    height: 774,
    viewBox: "0 0 1882 774",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_693)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1882.39 177.649C1732.7 128.707 1548.72 99.8594 1349.84 99.8594C847.535 99.8594 440.338 283.87 440.338 510.859C440.338 610.997 519.585 702.769 651.286 774.07C422.916 699.404 274.338 577.973 274.338 440.859C274.338 213.87 681.535 29.8594 1183.84 29.8594C1464.55 29.8594 1715.56 87.3276 1882.39 177.649Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.6,
    y: 280.473,
    width: 467.519,
    height: 95.7333,
    transform: "rotate(90 1138.6 280.473)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.75 431.821L252.069 494.553C302.918 579.539 403.301 661.458 537.61 730.068C418.613 639.138 354.616 536.148 370.203 437.231C370.828 433.267 371.576 429.335 372.447 425.437L318.945 417.006L102.154 0C67.62 2.96464 33.5494 6.65783 0 11.0487L218.75 431.821Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1882,
    height: 774
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a424ee97649d0e03221cafac4d73b1b1.svg";
export { ForwardRef as ReactComponent };